import React from 'react';
import { useI18n } from '../use-i18n';
import { formatNumber, formatRoundNumber } from './format-number';
export function useFormatNumber() {
  const i18n = useI18n();
  const _formatNumber = React.useCallback(function (value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return formatNumber(value, i18n.locale, options);
  }, [i18n.locale]);
  return {
    formatNumber: _formatNumber
  };
}
export function useFormatRoundNumber() {
  const i18n = useI18n();
  const _formatRoundNumber = React.useCallback(function (value) {
    let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return formatRoundNumber(value, precision, i18n.locale, options);
  }, [i18n.locale]);
  return {
    formatRoundNumber: _formatRoundNumber
  };
}
//# sourceMappingURL=use-format-number.js.map